var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklistActivities({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.49935V17.5062C17.5 17.9627 17.1292 18.3327 16.6722 18.3327H3.32783C2.87063 18.3327 2.5 17.9533 2.5 17.5062V2.49252C2.5 2.03606 2.87079 1.66602 3.32783 1.66602H16.6667C17.1269 1.66602 17.5 2.03912 17.5 2.49935ZM9.41075 10.9338L7.34835 8.87135L6.16984 10.0499L9.41075 13.2908L14.1247 8.57677L12.9462 7.39825L9.41075 10.9338Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistActivities);
export default __webpack_public_path__ + "static/media/checklist-activities.0034ba7b17f10d1957e8ff290dc2c820.svg";
export { ForwardRef as ReactComponent };